import { Box, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { useState } from "react";
import { EditableCopyViewModel } from "../../Globals/ViewModels/EditableCopyViewModel";
import { ForgotPasswordViewModel } from "./ForgotPasswordViewModel";
import { CustomInput } from "Globals/Styles/AppStyling";
import { useObserver } from "mobx-react-lite";
import styled from "styled-components";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { useRouter, getHistory } from "@shoothill/core";

const BackgroundImageContainer = styled(Box)`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    height: auto;
    background-image: url("login_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;

const Row = styled(Box)`
    display: flex;
    margin: 30px 0;
    @media (max-width: 768px) {
        justify-content: center;
        margin: 15px 0;
    }
`;

const useStyles = makeStyles({
    wrapper: {
        padding: "90px 120px 0 80px",
        backgroundColor: "#ffffffef",

        "@media (max-width:768px)": {
            padding: "50px 10px 10px",
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
        },
    },
    p1: {
        fontSize: "18px",
        "@media (max-width:768px)": {
            textAlign: "center",
        },
    },
    form: {
        "@media (max-width: 768px)": {
            width: "100%",
            marginTop: "80px",
        },
    },
    input: {
        "& .MuiInputBase-input": {
            "@media (max-width: 768px)": {
                height: "48px",
                boxSizing: "border-box",
                width: "300px",
            },
        },
        "& .MuiFormControl-root": {
            "@media (max-width: 768px)": {
                boxSizing: "border-box",
                width: "300px",
                margin: "15px 0",
            },
        },
    },
});

export const ForgotPasswordView = () => {
    const [viewModel] = useState(() => new ForgotPasswordViewModel());
    const [viewModelEditableCopy] = useState(() => new EditableCopyViewModel());
    const { history } = useRouter();
    const [errorMessage, setErrorMessage] = useState("");
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    const [isLoading, setIsLoading] = useState(false);
    const classes = useStyles();

    const doSubmit = async (e: any) => {
        e.preventDefault();
        if (await viewModel.isModelValid()) {
            setIsLoading(true);
            const apiResult: any = await viewModel.ForgotPasswordAsync();
            setIsLoading(false);
            if (apiResult !== null) {
                if (apiResult.wasSuccessful) {
                    history.push(`/forgotpassword-success`);
                } else {
                    if (apiResult && apiResult.errors && apiResult.errors.length > 0) {
                        setErrorMessage("* " + apiResult.errors[0].message);
                    } else {
                        setErrorMessage("* Unknown error has occurred.");
                    }
                }
            }
        }
    };

    return useObserver(() => (
        <>
            <BackgroundImageContainer>
                <Box className={classes.wrapper}>
                    <Row>
                        <img
                            src="/hightownLogo.svg"
                            alt="Hightown"
                            style={isMobile ? { width: "250px" } : { cursor: "pointer", width: "363px" }}
                            onClick={() => getHistory().push("/")}
                        />
                    </Row>
                    <Row>
                        <Typography style={{ fontSize: "28px", fontWeight: "bold" }}>Forgot password</Typography>
                    </Row>
                    <Row>
                        <Typography className={classes.p1}>Welcome to the Hightown Housing Group customer application portal.</Typography>
                    </Row>
                    <form onSubmit={doSubmit} className={classes.form}>
                        <Row>
                            {errorMessage !== "" && (
                                <Typography variant="caption" style={{ color: "red" }}>
                                    {errorMessage}
                                </Typography>
                            )}
                        </Row>
                        <Row>
                            <CustomInput className={classes.input} type="email" label="Email Address" validateOnBlur={true} viewModel={viewModel} fieldName="emailAddress" />
                        </Row>
                        <Row>
                            <StyledButton disabled={isLoading} style={{ margin: 0 }} type="submit">
                                {viewModel.IsLoading ? <span>Please wait...</span> : <span>Forgot password</span>}
                            </StyledButton>
                        </Row>
                    </form>
                </Box>
            </BackgroundImageContainer>
        </>
    ));
};
